import {
    CONNECTOR_OAUTH_RESUME_KEY,
    CONNECTOR_OAUTH_STARTED_AT_MS_KEY,
} from 'src/constants/sessionStorage';

export const CONNECTOR_AUTH_SESSION_MAX_AGE_MS = 10 * 60 * 1000;

const parseStartedAtMs = (rawValue: string | null): number | null => {
    if (!rawValue) {
        return null;
    }

    const startedAtMs = Number.parseInt(rawValue, 10);
    if (Number.isNaN(startedAtMs)) {
        return null;
    }

    return startedAtMs;
};

export const hasFreshConnectorAuthSession = (
    getItem: (key: string) => string | null,
    nowMs: number = Date.now(),
): boolean => {
    const connectorResume = getItem(CONNECTOR_OAUTH_RESUME_KEY);
    if (!connectorResume) {
        return false;
    }

    const startedAtMs = parseStartedAtMs(getItem(CONNECTOR_OAUTH_STARTED_AT_MS_KEY));
    if (startedAtMs === null) {
        return false;
    }

    const ageMs = nowMs - startedAtMs;
    return ageMs >= 0 && ageMs <= CONNECTOR_AUTH_SESSION_MAX_AGE_MS;
};

export const shouldPreserveFreshConnectorAuthSessionForLoginError = ({
    isConnectorOAuthLogin,
    authError,
    getItem,
    nowMs = Date.now(),
}: {
    isConnectorOAuthLogin: boolean;
    authError: string | null;
    getItem: (key: string) => string | null;
    nowMs?: number;
}): boolean => {
    const normalizedError = (authError || '').trim();
    if (isConnectorOAuthLogin || !normalizedError) {
        return false;
    }

    return hasFreshConnectorAuthSession(getItem, nowMs);
};

export const clearConnectorAuthSession = (removeItem: (key: string) => void): void => {
    removeItem(CONNECTOR_OAUTH_RESUME_KEY);
    removeItem(CONNECTOR_OAUTH_STARTED_AT_MS_KEY);
};
